module.exports = __webpack_public_path__ + "img/CLS-P-370.38ff799c.svg";